import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const QuotationInvoiceTemplate = ({
  headerBase64,
  footerBase64,
  dgSignBase64,
  watermarkBase64,
  quotation,
  enquiry,
  quotationData = [],
  invoice_date,
  grandTotal,
  numberToWords,
  selectedValue,
  type,
  bankAc,
  invoice_no,
  tax_type,
  tax_id,
  currency,
  scope,
}) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const margin = 6;
  const headerHeight = 28; // Reduced from 28
  const footerHeight = footerBase64 ? 18 : 8; // Reduced from 25
  const contentTop = headerHeight - 2;

  let isFirstPage = true;

  const colors = {
    primary: [220, 220, 220],
    secondary: [100, 100, 100],
    lightGray: [250, 250, 250],
    mediumGray: [240, 240, 240],
    border: [210, 210, 210],
    highlight: [245, 245, 245],
    textDark: [80, 80, 80],
  };

 const addHeader = () => {
  if (!headerBase64) return;

  const imgProps = doc.getImageProperties(headerBase64);

  const imgWidth = 170; // make logo/header larger
  const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

  const x = (pageWidth - imgWidth) / 2;
  const y = 1;

  doc.addImage(
    headerBase64,
    "PNG",
    x,
    y,
    imgWidth,
    imgHeight
  );
};

  const addWatermark = () => {
    if (!watermarkBase64) return;

    const wmWidth = pageWidth / 3; // Reduced from /2
    const wmHeight = wmWidth;
    const wmX = (pageWidth - wmWidth) / 2;
    const wmY = (pageHeight - wmHeight) / 2;

    doc.setGState(new doc.GState({ opacity: 0.04 })); // Reduced opacity
    doc.addImage(watermarkBase64, "PNG", wmX, wmY, wmWidth, wmHeight);
    doc.setGState(new doc.GState({ opacity: 1 }));
  };

  const addPageFooter = () => {
    doc.setFontSize(8);
    doc.setTextColor(...colors.secondary);
    doc.text(
      `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
      pageWidth - margin,
      pageHeight - 5,
      { align: "right" }
    );

    if (footerBase64) {
      doc.addImage(
        footerBase64,
        "PNG",
        0,
        pageHeight - footerHeight,
        pageWidth,
        footerHeight
      );
    }
  };

  const formatDate = (value) =>
    value
      ? new Date(value).toLocaleDateString("en-GB")
      : new Date().toLocaleDateString("en-GB");

  const money = (value) =>
    Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });






    const drawTopSection = (startY = contentTop) => {
  let y = startY;

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...colors.textDark);
  doc.text(type, pageWidth / 2, y + 3, { align: "center" });

  y += 5;

  const invoiceNum =
    type === "INVOICE"
      ? invoice_no || "-"
      : quotation?.qu_no || invoice_no || "-";

  const numberLabel =
    type === "INVOICE" ? "INVOICE No" : "QUOTATION No";

  const leftBoxWidth = (pageWidth - 2 * margin - 4) / 2;
  const rightBoxWidth = leftBoxWidth;

  const leftBoxX = margin;
  const rightBoxX = leftBoxX + leftBoxWidth + 4;
  const cardStartY = y;

  const addrValue = enquiry?.address || "-";
  const addrLines = doc.splitTextToSize(addrValue, leftBoxWidth - 25);

  const rowGap = 4.2;

  let tempY = cardStartY + 2;
  tempY += rowGap;
  tempY += rowGap;
  tempY += rowGap;
  tempY += rowGap;
  tempY += Math.max(addrLines.length - 1, 0) * rowGap;
  tempY += rowGap;

  if (tax_id || enquiry?.tax_id) {
    tempY += rowGap;
  }

  const cardHeight = tempY - cardStartY + 1;

  doc.setFillColor(...colors.lightGray);
  doc.setDrawColor(...colors.lightGray);

  doc.roundedRect(leftBoxX, cardStartY, leftBoxWidth, cardHeight, 2, 2, "FD");
  doc.roundedRect(rightBoxX, cardStartY, rightBoxWidth, cardHeight, 2, 2, "FD");

  let leftY = cardStartY + 4;

  doc.setFontSize(7.5);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...colors.secondary);
  doc.text(`${numberLabel}: ${invoiceNum}`, leftBoxX + 5, leftY);

  leftY += rowGap;

  doc.setFontSize(8);
  doc.text("Customer Details:", leftBoxX + 5, leftY);

  leftY += rowGap;

  doc.setFontSize(7.5);
  doc.text(enquiry?.name || "-", leftBoxX + 5, leftY);

  leftY += rowGap;

  doc.setFont("helvetica", "bold");
  doc.text("Address:", leftBoxX + 5, leftY);

  doc.setFont("helvetica", "normal");
  addrLines.forEach((line, index) => {
    if (index > 0) leftY += rowGap;
    doc.text(line, leftBoxX + 18, leftY);
  });

  leftY += rowGap;

  doc.setFont("helvetica", "bold");
  doc.text("Contact:", leftBoxX + 5, leftY);

  doc.setFont("helvetica", "normal");
  doc.text(String(enquiry?.mobile_no || "-"), leftBoxX + 18, leftY);

  const taxTypeValue = tax_type || enquiry?.tax_type;
  const taxIdValue = tax_id || enquiry?.tax_id;

  if (taxIdValue) {
    leftY += rowGap;

    const taxLabel = taxTypeValue ? `${taxTypeValue} ID:` : "Tax ID:";

    doc.setFont("helvetica", "bold");
    doc.text(taxLabel, leftBoxX + 5, leftY);

    doc.setFont("helvetica", "normal");
    doc.text(String(taxIdValue), leftBoxX + 22, leftY);
  }

  const dateText = `Date: ${formatDate(invoice_date)}`;

  doc.setFontSize(7);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...colors.secondary);

  doc.text(dateText, rightBoxX + rightBoxWidth - 5, cardStartY + 5, {
    align: "right",
  });

  return cardStartY + cardHeight ;
};

 


  addHeader();
  addWatermark();

 

  const htmlToScopeLines = (html = "") => {
  const parser = new DOMParser();
  const docHtml = parser.parseFromString(html, "text/html");
  const lines = [];

  const walk = (node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = node.tagName.toLowerCase();
      const text = node.textContent.trim();

      if (!text) return;

      if (tag === "h1") return lines.push({ text, type: "h1" });
      if (tag === "h2") return lines.push({ text, type: "h2" });
      if (tag === "h3") return lines.push({ text, type: "h3" });
      if (tag === "li") return lines.push({ text: `• ${text}`, type: "li" });
      if (tag === "p") return lines.push({ text, type: "p" });
    }

    node.childNodes.forEach(walk);
  };

  docHtml.body.childNodes.forEach(walk);
  return lines;
};

const drawScopeSection = (startY) => {
  const scopeData = scope || quotation?.scope || enquiry?.scope;

  if (!scopeData) return startY;

  const scopeLines = htmlToScopeLines(scopeData);

  if (!scopeLines.length) return startY;

  const boxWidth = pageWidth - 2 * margin;

  let allLines = [];

  scopeLines.forEach((line) => {
    const wrapped = doc.splitTextToSize(line, boxWidth - 8);
    allLines.push(...wrapped);
  });

  const headingHeight = 3;
  const lineHeight = 3.2;
  const bodyHeight = allLines.length * lineHeight + 3;

  // Full gray container
  doc.setFillColor(...colors.lightGray);
  doc.roundedRect(
    margin,
    startY,
    boxWidth,
    headingHeight + bodyHeight,
    2,
    2,
    "F"
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(...colors.textDark);
  doc.text("Scope of the Quotation", margin + 3, startY + 4);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.5);

  let textY = startY + headingHeight + 4;

  scopeLines.forEach((line) => {
  if (line.type === "h1") {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
  } else if (line.type === "h2") {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
  } else if (line.type === "h3") {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
  } else {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);
  }

  const wrapped = doc.splitTextToSize(line.text, boxWidth - 8);

  wrapped.forEach((wrappedLine) => {
    doc.text(wrappedLine, margin + 3, textY);
    textY += line.type?.startsWith("h") ? 4.2 : lineHeight;
  });
});

 return textY ;
};

 let tableStartY = drawTopSection();

  tableStartY = drawScopeSection(tableStartY );

  const tableRows = quotationData.map((item, idx) => {
    const qty = parseFloat(item.qty) || 0;
    const unitPrice = parseFloat(item.unitprice) || 0;
    const taxPercent = parseFloat(item.tax) || 0;
    const rowTotal =
      item.totalprice !== undefined && item.totalprice !== null
        ? parseFloat(item.totalprice) || 0
        : qty * unitPrice;

    return [
        idx + 1,
        item.description || "-",
        item.hsn_code || "-",
        item.unit || "-",
        qty.toFixed(0),
        money(unitPrice),
        Number.isInteger(taxPercent) ? String(taxPercent) : String(taxPercent),
        money(rowTotal),
      ];
  });

  autoTable(doc, {
    startY: tableStartY ,
    tableWidth: pageWidth - 2 * margin,
    head: [
      [
        "SI\nNO",
        "DESCRIPTION",
        "HSN/SAC",
        "UNIT",
        "QTY",
        "UNIT PRICE",
        "TAX\n(%)",
        "TOTAL",
      ],
    ],
    body: tableRows,
    margin: {
      left: margin,
      right: margin,
      top: headerHeight + 1,
      bottom: footerHeight + 10,
    },
    theme: "striped",
    headStyles: {
      fillColor: colors.primary,
      textColor: colors.textDark,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
      fontSize: 8,
    },
    bodyStyles: {
      fontSize: 7.5,
      textColor: colors.secondary,
      valign: "middle",
    },
    columnStyles: {
  0: { halign: "center", cellWidth: 10 },  // SI No
  1: { halign: "left", cellWidth: 70 },    // Description
  2: { halign: "center", cellWidth: 22 },  // HSN/SAC
  3: { halign: "center", cellWidth: 18 },  // Unit
  4: { halign: "center", cellWidth: 14 },  // Qty
  5: { halign: "right", cellWidth: 24 },   // Unit Price
  6: { halign: "center", cellWidth: 14 },  // Tax
  7: { halign: "right", cellWidth: 26 },   // Total
},
    didDrawPage: () => {
      addWatermark();
      addPageFooter();

      if (!isFirstPage) addHeader();
      if (isFirstPage) isFirstPage = false;
    },
  });

  let subTotal = 0;
  let totalTaxAmount = 0;

  quotationData.forEach((item) => {
    const qty = parseFloat(item.qty) || 0;
    const unitPrice = parseFloat(item.unitprice) || 0;
    const taxPercent = parseFloat(item.tax) || 0;
    const rowTotal = qty * unitPrice;
    const rowTax = rowTotal * (taxPercent / 100);

    subTotal += rowTotal;
    totalTaxAmount += rowTax;
  });

  let sgstAmount = 0;
  let cgstAmount = 0;
  let igstAmount = 0;

  if ((tax_type || "").toUpperCase() === "IGST") {
    igstAmount = totalTaxAmount;
  } else {
    sgstAmount = totalTaxAmount / 2;
    cgstAmount = totalTaxAmount / 2;
  }

  const finalTotal =
    typeof grandTotal === "number" && grandTotal > 0
      ? grandTotal
      : subTotal + totalTaxAmount;

  let currentY = doc.lastAutoTable.finalY + 0.2;

  const summaryWidth = 75; // Reduced from 80
  const summaryX = pageWidth - margin - summaryWidth;

  const summaryRows = [["Sub Total", subTotal]];

  if (igstAmount > 0) {
    summaryRows.push(["IGST", igstAmount]);
  } else {
    summaryRows.push(["SGST", sgstAmount]);
    summaryRows.push(["CGST", cgstAmount]);
  }

  summaryRows.push(["Total", finalTotal]);

  summaryRows.forEach((row, i) => {
    const rowY = currentY + i * 6;

    if (row[0] === "Total") {
      doc.setFillColor(...colors.mediumGray);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...colors.textDark);
    } else {
      doc.setFillColor(...colors.lightGray);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(...colors.secondary);
    }

    doc.rect(summaryX, rowY, summaryWidth, 7.5, "F"); // Reduced height from 8
    doc.setFontSize(7.5); // Reduced from 9
    doc.text(row[0], summaryX + 3, rowY + 5);
    doc.text(money(row[1]), summaryX + summaryWidth - 3, rowY + 5, {
      align: "right",
    });
  });

  if (bankAc) {
    const bankWidth = summaryX - margin - 5;
    const bankX = margin;
    let bankY = currentY;

    doc.setFillColor(...colors.mediumGray);
    doc.rect(bankX, bankY, bankWidth, 5.5, "F"); // Reduced height from 6

    doc.setFontSize(8); // Reduced from 10
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...colors.secondary);
    doc.text("BANK DETAILS", bankX + 2, bankY + 4);

    bankY += 8; // Reduced from 10

    doc.setFontSize(7.5); // Reduced from 8.5
    doc.setFont("helvetica", "normal");

    const bankLines = [
      `Account Holder: ${bankAc.holder_name || ""}`,
      `Bank: ${bankAc.bank_name || ""}`,
      `Account No: ${bankAc.ac_no || ""}`,
      `IFSC: ${bankAc.ifsc_code || ""}`,
      `${(bankAc.bank_address || "").replace(/\n/g, " ")}`,
    ];

    bankLines.forEach((line) => {
      const wrapped = doc.splitTextToSize(line, bankWidth - 4);
      wrapped.forEach((part) => {
        doc.text(part, bankX + 2, bankY);
        bankY += 3.5; // Reduced from 5.3
      });
    });
  }

  currentY += summaryRows.length * 6.2;

  const formattedTotal = parseFloat(finalTotal.toFixed(2));
  const rupees = Math.floor(formattedTotal);
  const paise = Math.round((formattedTotal - rupees) * 100);

  let words = numberToWords(rupees);
  if (paise > 0) {
    words += ` and ${numberToWords(paise)} Paise`;
  }
  words += " Only";

  const wordsLabel = "Grand Total (In Words): ";
const wordsBoxWidth = pageWidth - 2 * margin;

doc.setFont("helvetica", "bold");
doc.setFontSize(8);
const labelWidth = doc.getTextWidth(wordsLabel);

doc.setFont("helvetica", "normal");
doc.setFontSize(7.5);

const wrappedWords = doc.splitTextToSize(
  words,
  wordsBoxWidth - labelWidth - 8
);

const wordsLineH = 4;
const wordsBoxHeight = Math.max(7, 3 + wrappedWords.length * wordsLineH);

if (currentY + wordsBoxHeight > pageHeight - footerHeight - 5) {
  addPageFooter();
  doc.addPage();
  addHeader();
  addWatermark();
  currentY = headerHeight + 15;
}

doc.setFillColor(...colors.highlight);
doc.setDrawColor(...colors.border);
doc.roundedRect(
  margin,
  currentY,
  wordsBoxWidth,
  wordsBoxHeight,
  1.5,
  1.5,
  "FD"
);

const textBaseY = currentY + 4.5;

doc.setFont("helvetica", "bold");
doc.setFontSize(8);
doc.setTextColor(...colors.secondary);
doc.text(wordsLabel, margin + 2, textBaseY);

doc.setFont("helvetica", "normal");
doc.setFontSize(7.5);

wrappedWords.forEach((line, idx) => {
  doc.text(
    line,
    margin + 2 + labelWidth + 2,
    textBaseY + idx * wordsLineH
  );
});

currentY += wordsBoxHeight + 2;

  let finalTerms = [];

  if (selectedValue?.data) {
    const html = selectedValue.data;

    const withLineBreaks = html
      .replace(/<li[^>]*>/gi, "\n")
      .replace(/<\/li>/gi, "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<p[^>]*>/gi, "\n")
      .replace(/<\/p>/gi, "")
      .replace(/<\/?[^>]+(>|$)/g, "")
      .trim();

    finalTerms = withLineBreaks
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
  }

  if (finalTerms.length > 0) {
    if (currentY + 14 > pageHeight - footerHeight - 5) {
      addPageFooter();
      doc.addPage();
      addHeader();
      addWatermark();
      currentY = headerHeight + 15;
    }

    doc.setFillColor(...colors.mediumGray);
    doc.rect(margin, currentY, pageWidth - 2 * margin, 5.5, "F"); // Reduced height from 6

    doc.setFontSize(8); // Slightly reduced from 10
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...colors.secondary);
    doc.text("TERMS & CONDITIONS", margin + 2, currentY + 4);

    currentY += 7.5; // Reduced from 8

    // TERMS & CONDITIONS STYLING - KEPT UNCHANGED
    doc.setFontSize(7);
    doc.setFont("helvetica", "normal");

    finalTerms.forEach((line) => {
      const wrapped = doc.splitTextToSize(line, pageWidth - 2 * margin - 6);

      wrapped.forEach((wrappedLine, index) => {
        if (currentY + 4.8 > pageHeight - footerHeight - 5) {
          addPageFooter();
          doc.addPage();
          addHeader();
          addWatermark();
          currentY = headerHeight + 15;
        }

        doc.text(`${index === 0 ? "• " : "  "}${wrappedLine}`, margin + 3, currentY);
        currentY += 3.5;
      });
    });

    currentY += 3;
  }

  const sigWidth = pageWidth * 0.18;
  const sigHeight = sigWidth * 0.75; // Reduced from 0.9
  const sigX = pageWidth - sigWidth - margin;

  if (currentY + sigHeight + 8 > pageHeight - footerHeight - 5) {
    addPageFooter();
    doc.addPage();
    addHeader();
    addWatermark();
    currentY = headerHeight + 15;
  }

  if (dgSignBase64) {
    doc.addImage(dgSignBase64, "PNG", sigX, currentY, sigWidth, sigHeight);
    doc.setFontSize(7);
    doc.setFont("helvetica", "bold");
    doc.text("Authorized Signatory", sigX, currentY + sigHeight + 2);
  }

  addPageFooter();

  return doc;
};

export default QuotationInvoiceTemplate;